
!function ($) {

	function Shelve($container) {
		this.init($container);
	}

	Shelve.prototype = {
		
		init: function ($container) {
			this.$container = $($container);
			this.$drawer = this.$container.find('.mk-shelve-drawer');
			this.$aside = this.$container.find('.mk-shelve-aside');
			this.bind();
		},

		bind: function () {

			var me = this;

		    // WF-3564 create custtom event to resize interactive chart
		    var resizeInteractiveChartEvent = document.createEvent('Event');
		    resizeInteractiveChartEvent.initEvent('resizeInteractiveChart', true, true)

			this.$aside.on('click.mk-shelve', '.mk-shelve-toggle', function (e) {
				e.preventDefault();
				me.toggle();

				// WF-3564 dispatch resize interactive chart custom event
				e.target.dispatchEvent(resizeInteractiveChartEvent)
			});
		},

		toggle: function () {
			sendOmnitureData(this);
			checkInteractiveChartRail(this);
			return this.$container.hasClass('opened') && this.close()
				|| this.open();
		},

        open: function () {
            if ($('#result-row').length > 0) {
                $('#result-row')[0].style.display = "block";
            }
			this.$container.addClass('opened');
			this.$container.find('.mk-shelve-toggle').attr('aria-label', 'left rail open. click to close.');
            this.$container.trigger('opened.mk-shelve');
            if (document.getElementsByClassName('edit-filter').length > 0) {
                document.getElementsByClassName('edit-filter')[1].classList.add('mf-screener-dark-right-rail');
            }            
			return this;
		},
		
        close: function () {
            if ($('#result-row').length > 0) {
                $('#result-row')[0].style.display = "none";
            }
			this.$container.removeClass('opened');
			this.$container.find('.mk-shelve-toggle').attr('aria-label', 'left rail closed. click to open.');
            this.$container.trigger('closed.mk-shelve');
            if (document.getElementsByClassName('edit-filter').length > 0) {
                document.getElementsByClassName('edit-filter')[1].classList.remove('mf-screener-dark-right-rail');
            }
			return this;
		}
	};

	$.FED = $.FED || {};
	$.FED.Shelve = Shelve;

	$.fn.mkshelve = function () {
		return this.each(function () {
			var $el = $(this);
			$el.data('mk-shelve', $el.data('mk-shelve') || new Shelve($el));
		});
	};

	$(function () {
		$('.mk-shelve').mkshelve();
	});

    function sendOmnitureData(caller) {
		if (caller == null) {
			return;
		}
		if (caller.$aside.length < 1) {
			return;
        }
        if (caller.$aside.closest('.f2-app-container').length === 0) {
            return;
        }		
        if (caller.$aside.closest('.f2-app-container').length > 0 &&
            caller.$aside.closest('.f2-app-container').attr('class').indexOf('com_wfebrokerage_desktop_etfadvancedscreener') > -1) {
			Omniture.Track({ pageName: 'wfa:auth:Stock_Screener:Advanced Screener Page-Full Width Display', events : 'event95'});
		}
	};

	function checkInteractiveChartRail () {
		
	}

}(window.jQuery);